// import Switch from 'react-ios-switch';
import { styled } from "@mui/material/styles";
import Switch, { type SwitchProps } from "@mui/material/Switch";
import React from "react";

const SwitchCustom = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: "2.25rem",
  height: "1.25rem",
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: "0.11rem",
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(1rem)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#F35B6A",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: "1rem",
    height: "1rem",
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2 + "rem",
    backgroundColor: "#9D9D9D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default SwitchCustom;
